import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import CompanyGoalsBody from "components/CompaniesComponents/CompanyDetails/CompanyGoals/CompanyGoalsBody";

const CompanyGoals = () => {
  // -------- for title ------------
  useEffect(() => {
    document.title = "Clinics";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="companies" />
      <CompanyGoalsBody />
    </main>
  );
};

export default CompanyGoals;
